

<main dir="rtl" class="p-2">

    <div [formGroup]="eventModel" class="row gx-2 gy-2 p-2">

        <div class="col-12 col-md-2">
    
            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY-MM-DD'" 
            
                [dateFormat]="'jYYYY/jMM/jDD'">
    
                <input type="text" formControlName="strDate" class="form-control text-end"  />
    
            </ng-persian-datepicker>
    
        </div>

        <div [ngClass]="!bDailyEvent ? 'col-12 col-md-1' : 'd-none' ">

            <div class="input-group clockpicker">

                <input type="text" class="form-control text-center" readonly formControlName="strTime" id="time">

                <span class="input-group-addon">

                <span class="glyphicon glyphicon-time"></span>

                </span>

            </div>

        </div>

        <div class="col-12 col-md-2">

            <select class="form-select" id="domainDashbord" formControlName="iMobileDomain" (change)="bDailyEvent ? '' : changeDomain($event.target)">

                <option value="-1"> حوزه خدمت </option>

                <option *ngFor="let item of domain" value="{{item.iMobileDomain}}">{{item.strComment}}</option>

            </select>

        </div>

        <div class="col-12 col-md-2">

            <select class="form-select" (change)="bDailyEvent ? '' : changeTypeData($event.target)" formControlName="tiJournalType">

                <option value="-1"> نوع وقایع </option>

                <option *ngFor="let item of journalTypeData" value="{{item.tiJournalType}}">{{item.strComment}}</option>

            </select>

        </div>

        <div *ngIf="!bDailyEvent" class="col-12 col-md-2 d-flex flex-row align-items-center">

            <input type="checkbox" class="form-check mx-1" id="show-last-th" checked>

            <label for="show-last-th"> نمایش آخرین ستون </label>

        </div>

        <div class="col-12 col-md-2 text-end">

            <button class="btn btn-success" (click)="exportexcel('liveJournal')">
            
                خروجی اکسل

            </button>

        </div>

        <div class="col-12 col-md-1">

            <button class="btn btn-primary" (click)="search()">
            
                جستجو

            </button>

        </div>
    
    </div>

    <hr class="w-100 ">

    <div style="height: 88vh; overflow-y: auto;" id="scroll-handel">

        <input type="text" class="form-control my-3 mb-4" placeholder="جستجو کنید" (keyup)="filter_list($event.target)">

        <table class="table mt-1 dirI table-striped" id="liveJournal">
    
            <thead class="dirI">

                <tr class="text-center ">

                    <ng-container *ngIf="!bDailyEvent">

                        <th scope="col " class=""># </th>

                        <th scope="col" class=""> </th>
    
                        <th scope="col" class="" (click)="sortByDate()"> تاریخ </th>
    
                        <th scope="col" class=""> ساعت </th>
    
                        <th scope="col" class="">نوع واقعه </th>
    
                        <th scope="col" class="">نام راننده</th>
    
                        <th scope="col" class="">موبایل راننده </th>
    
                        <th scope="col" class="">پلاک </th>
    
                        <th scope="col" class="">حوزه خدمت </th>
    
                        <th scope="col" class="">نوع خودرو </th>
    
                        <th scope="col" class="">توضیحات </th>
    
                        <th class="d-none" scope="col">عرض جغرافیایی</th>
    
                        <th class="d-none" scope="col">طول جغرافیایی</th>
    
                        <th class="d-none" scope="col">گروه خودرو </th>
    
                        <th class="d-none" scope="col">کاربری </th>
    
                        <th class="d-none" scope="col">سرعت مجاز </th>

                    </ng-container>

                    <ng-container *ngIf="bDailyEvent">

                        <th scope="col " class=""> # </th>
    
                        <th scope="col" class=""> نوع خودرو </th>
    
                        <th scope="col" class=""> نام راننده </th>
        
                        <th scope="col" class=""> موبایل راننده </th>
    
                        <th scope="col" class=""> پلاک </th>
    
                        <th scope="col" class=""> حوزه خدمت </th>
    
                        <th scope="col" class=""> تخلف </th>

                        <th scope="col" class=""> تعداد </th>
    
                    </ng-container>
   
                </tr>

            </thead>
    
            <tbody>

                <ng-container *ngIf="!bDailyEvent">

                    <tr class="text-center  dirI " *ngFor="let item of EventsData;let i=index">

                        <th class="" [style.color]="journalTypeData[0].tiJournalType==item.tiJournalType ? 
                        
                            '#'+journalTypeData[0].strColor : (journalTypeData[1].tiJournalType==item.tiJournalType ?
                            
                            '#'+journalTypeData[1].strColor : (journalTypeData[2].tiJournalType==item.tiJournalType ?
                            
                            '#'+journalTypeData[2].strColor : '#000'))">
                            
                            {{i+1|faNum}}
                        
                        </th>
        
                        <th class="" [style.color]="journalTypeData[0].tiJournalType==item.tiJournalType ?
                        
                            '#'+journalTypeData[0].strColor : (journalTypeData[1].tiJournalType==item.tiJournalType ?
                            
                            '#'+journalTypeData[1].strColor : (journalTypeData[2].tiJournalType==item.tiJournalType ?
                            
                            '#'+journalTypeData[2].strColor : '#000'))"  data-bs-toggle="modal" data-bs-target="#map"
                            
                            (click)="openMap(item.fLat,item.fLon,item.strTime,item.strComment)">
                            
                            <i class="fa fa-map-marker mx-2 pointer"></i>
                        
                        </th>
        
                        <th class="" [style.color]="journalTypeData[0].tiJournalType==item.tiJournalType ?
                        
                            '#'+journalTypeData[0].strColor : (journalTypeData[1].tiJournalType==item.tiJournalType ?
                            
                            '#'+journalTypeData[1].strColor : (journalTypeData[2].tiJournalType==item.tiJournalType ?
                            
                            '#'+journalTypeData[2].strColor : '#000'))">
                            
                            {{item.strDate|faNum}}
    
                        </th>
        
                        <th class="" [style.color]="journalTypeData[0].tiJournalType==item.tiJournalType ?
                        
                            '#'+journalTypeData[0].strColor : (journalTypeData[1].tiJournalType==item.tiJournalType ?
                            
                            '#'+journalTypeData[1].strColor : (journalTypeData[2].tiJournalType==item.tiJournalType ?
                            
                            '#'+journalTypeData[2].strColor : '#000'))">
                            
                            {{item.strTime|faNum}}
                        
                        </th>
    
                        <th class="" [style.color]="journalTypeData[0].tiJournalType==item.tiJournalType ?
                        
                            '#'+journalTypeData[0].strColor : (journalTypeData[1].tiJournalType==item.tiJournalType ?
                            
                            '#'+journalTypeData[1].strColor : (journalTypeData[2].tiJournalType==item.tiJournalType ?
                            
                            '#'+journalTypeData[2].strColor : '#000'))">
                            
                            {{item.strJournalType_strComment}}
                        
                        </th>
    
                        <th class="" [style.color]="journalTypeData[0].tiJournalType==item.tiJournalType ?
                        
                            '#'+journalTypeData[0].strColor : (journalTypeData[1].tiJournalType==item.tiJournalType ?
                            
                            '#'+journalTypeData[1].strColor : (journalTypeData[2].tiJournalType==item.tiJournalType ?
                            
                            '#'+journalTypeData[2].strColor : '#000'))">
                            
                            {{item.strFullName}}
                        
                        </th>
    
                        <th class="" [style.color]="journalTypeData[0].tiJournalType==item.tiJournalType ?
                        
                            '#'+journalTypeData[0].strColor : (journalTypeData[1].tiJournalType==item.tiJournalType ?
                            
                            '#'+journalTypeData[1].strColor : (journalTypeData[2].tiJournalType==item.tiJournalType ?
                            
                            '#'+journalTypeData[2].strColor : '#000'))">
                            
                            {{item.strMobile|faNum}}
                        
                        </th>
                        
                        <th class="" [style.color]="journalTypeData[0].tiJournalType==item.tiJournalType ?
                        
                            '#'+journalTypeData[0].strColor : (journalTypeData[1].tiJournalType==item.tiJournalType ?
                            
                            '#'+journalTypeData[1].strColor : (journalTypeData[2].tiJournalType==item.tiJournalType ?
                            
                            '#'+journalTypeData[2].strColor : '#000'))">
                            
                            {{item.strVehicleNo}}
                        
                        </th>
    
                        <th class="" [style.color]="journalTypeData[0].tiJournalType==item.tiJournalType ?
                        
                            '#'+journalTypeData[0].strColor : (journalTypeData[1].tiJournalType==item.tiJournalType ?
                            
                            '#'+journalTypeData[1].strColor : (journalTypeData[2].tiJournalType==item.tiJournalType ?
                            
                            '#'+journalTypeData[2].strColor : '#000'))">
                            
                            {{item.strMobileDomain_strComment}}
                    
                        </th>
    
                        <th class="" [style.color]="journalTypeData[0].tiJournalType==item.tiJournalType ?
                        
                            '#'+journalTypeData[0].strColor : (journalTypeData[1].tiJournalType==item.tiJournalType ?
                            
                            '#'+journalTypeData[1].strColor : (journalTypeData[2].tiJournalType==item.tiJournalType ?
                            
                            '#'+journalTypeData[2].strColor : '#000'))">
                            
                            {{item.strMobileGroup_strComment}}
                        
                        </th>
    
                        <th class=" " [style.color]="journalTypeData[0].tiJournalType==item.tiJournalType ?
                        
                            '#'+journalTypeData[0].strColor : (journalTypeData[1].tiJournalType==item.tiJournalType ?
                            
                            '#'+journalTypeData[1].strColor : (journalTypeData[2].tiJournalType==item.tiJournalType ?
                            
                            '#'+journalTypeData[2].strColor : '#000'))">
                            
                            {{item.strComment}}
                        
                        </th>
    
                        <td class="d-none">{{item.fLat}}</td>
                        
                        <td class="d-none">{{item.fLon}}</td>
                        
                        <td class="d-none">{{item.strMobileType_strComment}}</td>
                        
                        <td class="d-none">{{item.strMobileGroup_strComment}}</td>
                        
                        <td class="d-none">{{item.tiMaxSpeed}}</td>
                        
                    </tr>

                </ng-container>

                <ng-container *ngIf="bDailyEvent">

                    <tr class="text-center  dirI" *ngFor="let item of EventsData; let i=index">

                        <td class=""> {{ i + 1 | faNum }} </td>

                        <td> {{item.strMobileType_strComment}} </td>

                        <td> {{item.strFullName}} </td>

                        <td> {{item.strMobile | faNum }} </td>

                        <td> {{item.strVehicleNo | faNum }} </td>

                        <td> {{item.strMobileDomain_strComment | faNum }} </td>

                        <td> {{ item.strJournalType_strComment }} </td>

                        <td [ngClass]="(item.iCount > 2 && item.iCount < 5) ? 'text-primary fw-bold lead' : (item.iCount > 5) ? 'text-danger fw-bold lead' : '' ">

                             {{ item.iCount | faNum }}
                            
                        </td>
                        
                    </tr>

                </ng-container>
    
            </tbody>
    
        </table>
    
    </div>


</main>

<!--Modal-->

<div class="modal" id="map" tabindex="-1" aria-labelledby="" aria-hidden="true">

    <div class="modal-dialog modal-lg">

        <div class="modal-content">

            <div class="modal-header dirI">

                <h5 class="modal-title" id="">نقشه</h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body">

                <div id="map-modal" class="position-sticky w-100" style="height: 400px;">

                    <div class="position-absolute" id="map_tooltip" data-bs-html="true">

                    </div>

                </div>

            </div>

        </div>

    </div>

</div>